import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18736 11459"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974604509696">
        <path
          d="M7716 11215c54 319 580 360 599-85 12-270 28-961-4-1207-46-361-588-397-601 77-7 255-29 1002 6 1215zM10427 11215c55 327 581 349 599-85 12-271 28-961-4-1207-47-361-588-397-601 77-7 255-30 1002 6 1215zM6037 10057c71-196-61-375-229-399-248-35-308 131-404 275-88 133-499 711-535 821-71 213 67 379 241 400 222 27 307-147 392-275 108-163 482-674 535-822zM15109 10057c32 104 437 674 531 816 97 146 159 303 389 283 173-16 305-187 253-385-26-100-448-698-533-826-86-130-166-314-393-289-174 18-311 193-247 401zM12684 10001c14 112 426 691 516 827 82 123 171 311 351 328 204 18 351-127 332-333-12-128-426-702-517-839-92-138-157-315-356-329-209-15-350 141-326 346zM3609 10123c150-284-221-785-599-212l-530 798c-91 184-1 393 179 439 241 60 329-111 415-241l406-610c15-22 129-173 129-174zM17202 10001c18 150 457 536 560 641 85 86 187 234 387 212 153-18 272-166 250-340-22-186-435-533-557-658-428-437-666-72-640 145zM1519 10057c64-175-44-347-180-388-214-64-328 72-415 160-112 113-527 492-571 617-81 234 164 660 593 225 102-105 532-502 573-614zM5977 7722c-1105 1-2209 2-3313-2-539-1-1160 22-1693-17-401-49-200-1478-200-1769l-11-2517c-2-759-50-1719 15-2463 17-116 103-179 233-198 331-27 753-12 1113-13 725-3 1450-3 2174-1l3379 12 5081-12c1105-2 2211-2 3317 0 541 2 1153-20 1689 15 319 37 238 708 231 940-7 273-26 547-26 821l10 2518c2 765 49 1720-15 2471-11 90-106 182-206 197-335 29-765 14-1123 16-726 4-1453 3-2179 1l-3391-12c-1695 0-3390 10-5085 13zM40 868c-42 299-10 4547-10 5066 0 948-280 2367 870 2506 374 45 9923 10 10162 10 519 0 6458 36 6800-13 426-63 781-414 835-850 39-316 9-4533 9-5069 0-959 280-2365-878-2498-348-40-9940-7-10154-7-484 0-6467-34-6773 10C445 90 105 408 40 868z"
          className="fil0"
        />
        <path
          d="M3665 6631h11658l-187-1205-120-280H3721l-119 281-201 1202zM1374 3313h15995V1983c0-83-67-150-149-150H1524c-82 0-150 67-150 150v1330z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
